
import  gipsmapimg  from 'assets/images/THE PRESTIGE MASTER PLAN-RV3-4 1.png'



const GisMap = () => {


    
  return (
    <div className="w-full table-container  bg-white flex flex-col gap-2 pb-4">

<div className=' flex flex-col  sm:flex-row sm:justify-between  w-full px-3'>
  <p className="text-dark1 font-semibold">The Prestige Map</p> 
</div>


<img 
src={gipsmapimg}
alt="img"

 className='w-full  h-auto mt-4'
/>




     






   





      
    </div>
  );
};

export default GisMap;


      